'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIMediaBody;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UIMediaBody(_ref) {
  var children = _ref.children,
      className = _ref.className;

  return _react2.default.createElement(
    'div',
    { className: (0, _classNames2.default)('media-body', 'private-media__body', className) },
    children
  );
}

UIMediaBody.displayName = 'UIMediaBody';

UIMediaBody.propTypes = {
  children: _react.PropTypes.node,
  className: _react.PropTypes.string
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/layout/UIMediaBody.js
// module id = 533
// module chunks = 2 3